import React, { Component } from 'react';
import { Row, Col, Card } from 'reactstrap';
import { Button, Form, FormGroup, Label, Input, Alert, FormFeedback, Tooltip } from 'reactstrap';
import Loader from 'react-loaders';
import classnames from 'classnames';

import DateTime from 'react-datetime';
import moment from 'moment';

import { ButtonWithLoader, OroLoaderInline } from '../../../core';
import { toast } from "react-toastify";
import { onboardingService } from '../../services/onboarding';
import { store } from '../../../store';
import middlewareConstants from "../../../shared/middleware-constant";
import { middlewareService } from "../../../shared/service";
import IpvUploadTest from './IpvUploadTest';
import SampleDocCards from './SampleDocCards';
import PreviewModal from './PreviewModal';
import { getSample } from '../../helpers/docs';



const dummyDocTypes = [
  { text: "Upload your Signature", type: "sign", title: "Sign" },
  { text: "Upload your PAN", type: "pan", title: "PAN" },
  {
    text: "Upload your Address Proof ( Front Side )",
    type: "address",
    title: "Address Front",
  },
  {
    text: "Upload your Address Proof ( Back Side )",
    type: "address_1",
    title: "Address Back",
  },
  { text: "Upload Bank Proof", type: "bank", title: "Bank Proof" },
  { text: "Upload your Photo", type: "photo", title: "Photo" },
  { text: "Upload your IPV", type: "ipv", title: "Sign" },
];

const displayName = {
  sign: "Upload your Signature",
  pan: "Upload your PAN",
  address: "Upload your Address Proof (Front)",
  address_1: "Upload your Address Proof (Back)",
  photo: "Upload your Photo",
  ipv: "Upload your IPV",
  bank: "Upload your bank proof",
};
class UploadDocs extends Component {
  constructor(props) {
    super(props);

    this.state = {
      uploading: [],
      uploaded: [],
      maxFileSizeCheck: [],
      allDocsSubmitted: false,
      fileList: [null, null, null, null, null, null],
      filename: ['', '', '', '', '', ''],
      tooltipOpen: false
    };

    this.onChange = this.onChange.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.docUpload = this.docUpload.bind(this);
  }

  componentDidMount() {
    let storeState = store.getState()
    let pan = this.props.pan ? this.props.pan : store.getState().onboarding && store.getState().onboarding.addPan ? store.getState().onboarding.addPan.pan : "";
     
    let userStateArr = storeState.userState && storeState.userState.userStateArr ? storeState.userState.userStateArr : {} 
    if (!this.state.docsList || this.state.docsList.length === 0) {
      onboardingService.getUserDocState({pan: pan})
        .then(docsList => {
          var uploaded = [];

          if (docsList.data && docsList.data.length) {
            docsList.data.map(doc => {
              if (doc.status === "uploaded" || doc.status ==="accepted" ) {
                uploaded.push(doc.type);
              }
              return doc;
            });
          }
          let dummyDocs = dummyDocTypes.filter(doc => doc.type !== "bank" ? true : !userStateArr.anyBankVerified ? true : false )
          dummyDocs = dummyDocs.map(doc => {
            docsList.data.map(docTemp => {
              if (docTemp.type === doc.type) {
                doc.status = docTemp.status;
                doc.remarks = docTemp.remarks;
              }
            })
            return doc;
          })
          this.setState(
            {
              docsList: docsList.data && Object.keys(docsList.data) && Object.keys(docsList.data).length ? this.getCommonDocs(docsList.data) : dummyDocs,
              uploaded: uploaded,
              docStats: docsList.data,
              verifiedKyc : docsList.verified,
              isLoading: false
            }, () => {
              this.isAllDocsSubmitted();
            }
          )
        });
    }
  }

  getCommonDocs = (docs) => {
    return dummyDocTypes.filter((dummyDoc) => {
      let isPresent = false;
      docs.map(doc => {
        if (doc.type === dummyDoc.type) {
          isPresent = true
        }
      })
      return isPresent
    })
  }

  getUserKycStatus = (pan, dob) => {

    //=>user/stats api, which will take care of kyc check and doc list
    onboardingService.getUserDocState({ pan: pan })
      .then(resp => {

        if (!resp || !resp.success) {
          return toast.error("something went wrong!");
        }

        let allowedStatus = ["uploaded", "accepted"];
        let docsList = resp.data;
        let requiredDocs = docsList && docsList.filter(item => !(allowedStatus.includes(item.status)));
        requiredDocs = requiredDocs.map(item => {
          item.displayName = displayName[item.type]
          return item;
        })

        if (requiredDocs.length) {
          this.setState({
            requiredDocs: requiredDocs,
            verifiedKyc : resp.verified
          }, () => {
          });
        } 
      });
  }
  
   submitForm(e) {
    e.preventDefault();
    let storeState = store.getState()
    let isKyc = storeState.userState && storeState.userState.userStateArr || this.state.verifiedKyc ? (storeState.userState.userStateArr.isKyc || this.state.verifiedKyc) : false
    let kycDocsSubmitted =  (this.state.uploaded.indexOf("sign") !== -1)
    this.props.onComplete(this.props.stepName, { isNewKyc: !(isKyc && kycDocsSubmitted) });
   }

  onChange(e, index) {
    if (e.target.files.length > 0) {
      var name = e.target.name;
      var uploading = this.state.uploading;
      var uploaded = this.state.uploaded;
      var maxFileSizeCheck = this.state.maxFileSizeCheck;

      if (uploading.indexOf(name) === -1) {
        uploading.push(name);
      }

      if (uploaded.indexOf(name) !== -1) {
        uploaded.splice(uploaded.indexOf(name), 1);
      }

      if (maxFileSizeCheck.indexOf(name) !== -1) {
        maxFileSizeCheck.splice(maxFileSizeCheck.indexOf(name), 1);
      }

      //10000000B is 10MB, checking file size
      if (e.target.files[0].size > 10000000) {
        var uploading2 = this.state.uploading;
        var maxFileSizeCheck2 = this.state.maxFileSizeCheck;

        if (uploading2.indexOf(name) !== -1) {
          uploading2.splice(uploading.indexOf(name), 1);
        }

        if (maxFileSizeCheck2.indexOf(name) === -1) {
          maxFileSizeCheck2.push(name);
        }

        this.setState({
          uploading: uploading,
          errors: true,
          maxFileSizeCheck: maxFileSizeCheck2
        });
        return;
      }

      this.docUpload(e.target.name, e.target.files[0], index)
    }
  }

  

  docUpload(name, file, index) {
    var uploading = this.state.uploading;
    var uploaded = this.state.uploaded;
    var maxFileSizeCheck = this.state.maxFileSizeCheck;
    let pan = this.props.pan ? this.props.pan : store.getState().onboarding && store.getState().onboarding.addPan ? store.getState().onboarding.addPan.pan : "";
    if (!maxFileSizeCheck || !maxFileSizeCheck.length) {
      let fileListTemp = [...this.state.fileList]
      fileListTemp[index] = file
      // if (uploaded.indexOf(name) != -1) {
      //   uploaded.splice(uploaded.indexOf(name), 1);
      // }
      this.setState({
        file: file,
        fileList: fileListTemp,
        uploading: uploading,
        uploaded: uploaded
      }, () => {
        onboardingService.uploadDocs(name, this.props.email, pan, this.state.file)
          .then(response => {
            var uploading2 = this.state.uploading;
            var uploaded2 = this.state.uploaded;

            if (!response || !response.success) {
              if (uploading2.indexOf(name) !== -1) {
                uploading2.splice(uploading.indexOf(name), 1);
              }

              this.setState({
                uploading: uploading2
              });

              let msg = response && response.error;
              return toast.error(msg || "Doc not uploaded, please try after some time");
            }

            if (uploading2.indexOf(name) !== -1) {
              uploading2.splice(uploading.indexOf(name), 1);
            }

            if (uploaded2.indexOf(name) === -1) {
              uploaded2.push(name);
            }

            this.setState({
              uploaded: uploaded2,
              uploading: uploading2
            });
            this.isAllDocsSubmitted();
          })
      });
    }
  }

  submitDataToCVL = () => {
    let storeState = store.getState()
    let kycData = storeState.onboarding && storeState.onboarding.kycDetails;
    let isKyc = storeState.userState && storeState.userState.userStateArr || this.state.verifiedKyc ? (storeState.userState.userStateArr.isKyc || this.state.verifiedKyc) : false
    let kycDocsSubmitted =  (this.state.uploaded.indexOf("sign") !== -1)
    this.props.onComplete(this.props.stepName, { isNewKyc: !(isKyc && kycDocsSubmitted)  });

    if (false && kycData && Object.keys(kycData).length) {
      let payload = kycData;
      payload['isAjax'] = true;
      payload['Platform'] = 'web';
      payload['source'] = 'iosApp';
      payload['forBse'] = true;

      let url = "/app/v1/customerDashboard/profile/applyNewCan2";
      let requestOptions = middlewareConstants.requestWithCredentialsJsonBSE;
      requestOptions.body = JSON.stringify(payload);

      middlewareService.servicePost(process.env.REACT_APP_API_URL + url, requestOptions)
        .then(portfolioResponse => {
          return portfolioResponse;
        });
    }
  }

  isAllDocsSubmitted = () => {
    let storeState = store.getState();
    let isKyc = storeState.userState && storeState.userState.userStateArr || this.state.verifiedKyc ? (storeState.userState.userStateArr.isKyc || this.state.verifiedKyc) : false
    let kycDocsSubmitted =  (this.state.uploaded.indexOf("sign") !== -1)
    if (!(isKyc && kycDocsSubmitted) && (!(this.state.uploaded.indexOf("address") !== -1) ||
      !(this.state.uploaded.indexOf("sign") !== -1) ||
      !(this.state.uploaded.indexOf("photo") !== -1) ||
      !(this.state.uploaded.indexOf("sign") !== -1) ||
      !(this.state.uploaded.indexOf("ipv") !== -1))
    ) {
      this.setState({
        allDocsSubmitted: false
      });
      return
    }

    this.setState({
      allDocsSubmitted: true,
      kycUser: isKyc && kycDocsSubmitted
    });
    return
  }

  toggle = () => {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen
    });
  }

  openSampleModal = (type) => {

    this.setState({
      sampleData: getSample(type),
      isOpen: true
    })
  }

  openIPV = (index) => {
    let pan = this.props.pan ? this.props.pan : store.getState().onboarding && store.getState().onboarding.addPan ? store.getState().onboarding.addPan.pan : "";
    if (!pan) {
      return toast.error("Please Select PAN first")
    }
    
    let payload = {
      value: pan,
      type: "ipvOtp"
    }
    onboardingService.getOtp(payload)
      .then(response => {
        if (!response || !response.success) {
          toast.error(response.msg || "Something went wrong!");
          return;
        }
        this.setState({
          otp: response.otp,
          ipvIndex: index,
        }, () => {
          this.setState({
            openIpvModal: true
          })
        })
      })
  }

  previewImage = (index, isIpv) => {
    var reader = new FileReader();
    let dataURL = null;
    reader.readAsDataURL(this.state.fileList[index]);
    let classState = this
    reader.onload = () => {
      classState.setState({
        preview: isIpv ? this.state.fileList[index] : reader.result,
        isIpv: isIpv,

      }, () => {
        classState.setState({
          isPreviewOpen: true
        })
      })
    };
  }

  closeIPV = () => {
    this.setState({
      openIpvModal: false
    })
  }

  closePreview = () => {
    this.setState({
      isPreviewOpen: false
    })
  }

  closeSample = () => {
    this.setState({
      isOpen: false
    })
  }

  isIPVFile = (e,type,index) => {
    type !== "ipv" ?  this.onChange(e,index) : this.openIPV()
  }
  
  render() {

    return (
      <div className={classnames("upload-docs", { 'standalone': this.props.showHeader })}>
        <Row className="justify-content-center">
          {
            this.props.showHeader ? (
              <Col xs={12} md={12} lg={12}>
                <h2 className="font-weight-semi-bold font-size-triple mb-8">
                  Upload your documents
                </h2>
              </Col>
            ) : ''
          }
          <Col xs={12} md={this.props.showHeader ? 12 : 12} lg={this.props.showHeader ? 12 : 12}>
            {
              this.state.docsList ? (
                <Form className="login-form">
                  {
                    this.state.docsList.map((doc,index) => (
                      <Row className="border-bottom doc-container">
                      <Col lg={12} xs={12} >
                      <FormGroup key={doc.type} style={{ 'position': 'relative' }} className="pl-6 mb-6">
                        <Card className="d-flex flex-column w-100">
                                        <div className="d-flex  px-2 py-2">
                                          <label className="font-weight-semi-bold">{doc.text}</label>
                                          <div className="ml-auto">
                                            <Button color="muted" className="sample-btn" onClick={(e) => this.openSampleModal(doc.type)} style={{ width: "fit-content" }} >View Sample</Button>
                                          </div>
                                        </div>
                                        <div className="d-flex px-2 py-2">
                                          <label className="w-100 d-flex" onClick={doc.type === "ipv" ? () => this.openIPV(index) : console.log()}>
                                            {
                                               this.state.uploading.indexOf(doc.type) !== -1 ? (
                                                 <OroLoaderInline />
                                                ) : ''
                                            }
                                            {
                                              this.state.uploaded.indexOf(doc.type) !== -1 ?
                                              <div className="text-muted px-2 py-2 d-flex justify-content-center align-items-center"> 
                                                <img className="icon" src={process.env.REACT_APP_IMAGES_PATH + "done.webp"} alt=""/>
                                                <div className="px-1">Click here to upload again</div>
                                              </div>
                                              // <div className="text-muted px-2 py-2">{this.state.fileList[index].name}</div>
                                              :
                                              doc.status === "rejected" ?
                                              <div className="text-muted px-2 py-2 d-flex font-size-14 justify-content-center align-items-center"> 
                                                <img className="icon mr-2" src={process.env.REACT_APP_IMAGES_PATH + "reject.webp"} alt=""/>
                                                <div className="px-1">{doc.title} Rejected Click here upload again</div>
                                              </div>
                                              :
                                              <React.Fragment>
                                              <img src={process.env.REACT_APP_IMAGES_PATH + "upload.webp"} alt=""/>
                                              <div className="text-muted px-2 py-2">{doc.text}</div>
                                              </React.Fragment>
                                            }
                                           
                                            <input type="file" name={doc.type} onChange={(e) => this.isIPVFile(e,doc.type,index)} className="doc-input"
                                              accept=".png, .pdf, .jpg, .jpeg, video/*" disabled = {!(this.props.pan ? this.props.pan : store.getState().onboarding && store.getState().onboarding.addPan ? store.getState().onboarding.addPan.pan : "") || doc.type === "ipv"}/>
                                            
                                          </label>
                                          {
                                            this.state.uploaded.indexOf(doc.type) === -1 && doc.status === "rejected" &&  
                                            <div className="ml-auto text-muted font-size-13">
                                              Reason - <span className="text-danger">{doc.remarks}</span>
                                            </div>
                                          }
                                          <div className="ml-auto">
                                            {
                                              this.state.fileList &&  this.state.fileList[index] && (
                                                doc.type !== "ipv" ?
                                                <Button className="sample-btn" onClick={() => this.previewImage(index)}>preview</Button>
                                                :
                                                <Button className="sample-btn" onClick={() => this.previewImage(index,true)}>preview</Button>
                                                
                                              )
                                            }
                                          </div>
                                          
                                        </div>                                       
                                      </Card>
                        {/* <Label for="income"
                          className={classnames('text-muted', 'font-size-tiny', 'w-100', 'mb-2')} >
                          {doc.displayName}
                        </Label>

                        <div>
                          {
                            doc.type !== "ipv" ?
                              <input type="file" name={doc.type} onChange={this.onChange} className="docUpload"
                                accept="*" />
                              :
                              <input type="file" name={doc.type} onChange={this.onChange} className="docUpload"
                                ccept="video/*" capture="camera" id="recorder" />
                          }
                          {
                            doc.type == "ipv" &&
                            <div className="font-size-12 d-block">
                              <span>mp4, mpeg4, mkv, avi, 3gp are the supported video formats. </span>
                              <span id="ipvTooltip" className="mdi mdi-information-outline"></span>
                              <Tooltip placement="bottom" isOpen={this.state.tooltipOpen} target="ipvTooltip" toggle={this.toggle}>
                                In-Person Verification (IPV) video is a regulatory requirement of SEBI that needs to be completed in order to get your KYC registered.Please record a 5-10 second video holding your PAN card and Proof of Address.
                                </Tooltip>
                            </div>
                          }

                          {
                            this.state.maxFileSizeCheck.indexOf(doc.type) != -1 ? (
                              <FormFeedback className="d-block">
                                Your file is larger than 10MB, please upload a file that is under 10MB.
                              </FormFeedback>
                            ) : ''
                          }
                        </div>

                        <div style={{ position: 'absolute', left: 0, top: 0 }}>
                          {
                            this.state.uploading.indexOf(doc.type) != -1 ? (
                              <OroLoaderInline />
                            ) : ''
                          }

                          {
                            this.state.uploaded.indexOf(doc.type) != -1 ? (
                              <i className="mdi mdi-check-circle text-primary"></i>
                            ) : ''
                          }

                        </div> */}
                      </FormGroup>
                      </Col>
                      </Row>
                    ))
                  }

                  <FormGroup className="cta-block">
                    <ButtonWithLoader
                      text="Next"
                      isLoading={this.state.submitting}
                      color="primary"
                      className="w-100"
                      onClick={this.submitDataToCVL}
                      disabled={!this.state.allDocsSubmitted}
                    />
                  </FormGroup>
                </Form>
              ) : (
                  <div className="py-8 my-8 d-flex justify-content-center">
                    <OroLoaderInline />
                  </div>
                )
            }
          </Col>
        </Row>
        {
            this.state.openIpvModal &&
            <IpvUploadTest index={this.state.ipvIndex} pan={this.props.pan ? this.props.pan : store.getState().onboarding && store.getState().onboarding.addPan ? store.getState().onboarding.addPan.pan : ""} close={this.closeIPV}  isOpen={this.state.openIpvModal} onChange={this.onChange} otp={this.state.otp}/>
        }
        {
            this.state.isOpen &&
            <SampleDocCards close={this.closeSample} isOpen={this.state.isOpen} sampleData={this.state.sampleData}></SampleDocCards>
        }
          {
            this.state.isPreviewOpen &&
            <PreviewModal isIpv={this.state.isIpv} close={this.closePreview} isOpen={this.state.isPreviewOpen} preview={this.state.preview}></PreviewModal>
        }
      </div>
    );
  }
}

export default UploadDocs;